// src/components/Footer.js
import React from 'react';
import styled from 'styled-components';
import { Container, Typography } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // TikTok placeholder
import { socialLinks } from '../config/socialLinks';
import { colors } from '../colors';
import ContactLink from './ContactLink';

const FooterWrapper = styled.footer`
  background: ${colors.primaryDark};
  color: #fff;
  padding: 3rem 0 1.5rem 0;
  font-size: 1rem;
`;

const FooterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 2rem auto;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 1.5rem;
    align-items: flex-start;
  }
`;

const FooterCol = styled.div`
  flex: 1 1 200px;
  min-width: 200px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1.2rem;
  margin: 1rem 0;
  a {
    color: #fff;
    font-size: 2rem;
    transition: color 0.2s;
    &:hover {
      color: ${colors.primary};
    }
  }
`;

const QuickLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    margin-bottom: 0.5rem;
    a {
      color: #fff;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: ${colors.primary};
        text-decoration: underline;
      }
    }
  }
`;

const CountiesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  columns: 2;
  li {
    margin-bottom: 0.25rem;
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  color: #bbb;
  font-size: 0.95rem;
  margin-top: 2rem;
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <Container>
        <FooterSection>
          {/* Company & Contact */}
          <FooterCol>
            <Typography variant="h6" sx={{ color: colors.primary, fontWeight: 700, mb: 1 }}>
              Hawkins Carpet Cleaning
            </Typography>
            <div>
              <ContactLink href="tel:2703150389">270-315-0389</ContactLink>
              <ContactLink href="mailto:hawkinscarpet@gmail.com">hawkinscarpet@gmail.com</ContactLink>
              <div>715 Lafayette Drive,<br />Owensboro KY 42303 US</div>
            </div>
            <SocialIcons>
              <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer"><FacebookIcon fontSize="inherit" /></a>
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer"><InstagramIcon fontSize="inherit" /></a>
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer"><YouTubeIcon fontSize="inherit" /></a>
              <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer"><MusicNoteIcon fontSize="inherit" /></a>
            </SocialIcons>
          </FooterCol>

          {/* Quick Links */}
          <FooterCol>
            <Typography variant="h6" sx={{ color: colors.primary, fontWeight: 700, mb: 1 }}>
              Quick Links
            </Typography>
            <QuickLinks>
              <li><a href="/">Home</a></li>
              <li><a href="/pricing">Pricing</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/our-service">Our Service</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </QuickLinks>
          </FooterCol>

          {/* Counties We Serve */}
          <FooterCol>
            <Typography variant="h6" sx={{ color: colors.primary, fontWeight: 700, mb: 1 }}>
              Counties we serve!
            </Typography>
            <CountiesList>
              <li>Daviess, KY</li>
              <li>Hancock, KY</li>
              <li>Henderson, KY</li>
              <li>McLean, KY</li>
              <li>Ohio, KY</li>
              <li>Perry, IN</li>
              <li>Spencer, IN</li>
              <li>Warrick, IN</li>
              <li>Vanderburgh, IN</li>
            </CountiesList>
          </FooterCol>
        </FooterSection>
        <FooterBottom>
          Copyright © {new Date().getFullYear()} Hawkins Carpet Cleaning. All rights reserved.
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
}
